import ProductsPage from './views/products.page';
import EditProduct from './views/editProduct';

export default {
  views: {
    ProductsPage,
    EditProduct,
  },
};
